var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trace_pain",style:({'height':_vm.painNumber === 0|| _vm.painNumber ===5 ? '25rem':'30rem'})})
}
var staticRenderFns = []

export { render, staticRenderFns }